import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useFairePayDefaultedGate: IGateHook = () => {
  const modalType = useModalType();

  if (modalType === PromoModalType.FAIRE_PAY_DEFAULTED_MODAL) {
    return PromoModalType.FAIRE_PAY_DEFAULTED_MODAL;
  }

  return undefined;
};
